import { render, staticRenderFns } from "./ShipyardEditModal.vue?vue&type=template&id=89ca327a&scoped=true&"
import script from "./ShipyardEditModal.vue?vue&type=script&lang=js&"
export * from "./ShipyardEditModal.vue?vue&type=script&lang=js&"
import style1 from "./ShipyardEditModal.vue?vue&type=style&index=1&id=89ca327a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ca327a",
  null
  
)

export default component.exports